/**
 * 将值稳定序列化为 JSON。
 *
 * 设计说明：
 * JSON.stringify 对对象键顺序敏感，而 checksum 需要跨 session 稳定。因此这里递归排序普通对象键。
 *
 * @param value 待序列化值。
 * @returns 稳定 JSON 字符串。
 */
export function stableStringify(value: unknown): string {
  if (value === null || typeof value !== 'object') {
    return JSON.stringify(value);
  }

  if (Array.isArray(value)) {
    return `[${value.map((item) => stableStringify(item)).join(',')}]`;
  }

  const record = value as Record<string, unknown>;
  const keys = Object.keys(record).sort();
  const entries = keys.map((key) => `${JSON.stringify(key)}:${stableStringify(record[key])}`);

  return `{${entries.join(',')}}`;
}

/**
 * 创建轻量 checksum。
 *
 * 设计说明：
 * 该函数用于本地 crash recovery 的一致性检查，不用于安全加密。后续如果需要跨端可信校验，
 * 可以在 adapter 层替换为 WebCrypto SHA-256，但 cad-core 不直接依赖浏览器 API。
 *
 * @param value 待校验数据。
 * @returns checksum 字符串。
 */
export function createHistoryChecksum(value: unknown): string {
  const text = stableStringify(value);
  let hash = 0x811c9dc5;

  for (let index = 0; index < text.length; index += 1) {
    hash ^= text.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }

  return `fnv1a32:${(hash >>> 0).toString(16).padStart(8, '0')}`;
}

